const data = [
    {
      id: 1,
      image: "https://img.icons8.com/ios/64/000000/menu.png",
      title: "Analytical Skill",
      desc: " I was good at Understanding and Analyzing the user requirements and Created clear technical specifications. ",
    },
    {
      id: 2,
      image: "https://img.icons8.com/ios/40/000000/open-book.png",
      title: "Web Development",
      desc: " I can build highly efficient and scalable Single Page Web Apps with full Responsive.",
    },
    {
      id: 3,
      image: "https://img.icons8.com/fluency-systems-regular/64/000000/retro-tv.png ",
      title: "Methodology",
      desc: "Worked in Agile methodology and scrum framework for project execution.",
    },
    {
      id: 4,
      image: "https://img.icons8.com/material-outlined/64/000000/topic--v1.png ",
      title: "Backend Developement",
      desc: "Designed and developed the Microservices using Micro services Architecture with Eureka Server and Api Gateway connection.",
    },
    {
      id: 5,
      image: "https://img.icons8.com/ios-filled/64/000000/wifi.png ",
      title: "Full Stack Development",
      desc: "I am a professional full stack developer who uses coding to operate on both front- and back-end systems.",
    },
    {
      id: 6,
      image: "https://img.icons8.com/glyph-neue/50/000000/polyline.png ",
      title: "Explored Tools",
      desc: " I can work with tools like SonarQube, GitHub, VS-code, STS and Eclips.",
    },
  ]
  export default data;